import React, { useState, useEffect } from "react";
import { FaPlus } from "react-icons/fa";
import { ImMinus } from "react-icons/im";
import { eventClick, faqClick } from "../services/adobeDataLayer";
function Faq({ customADL, setCustomADL }) {
  const [showFaq, setShowFaq] = useState(false);


  const faqAccordionClick = () => {
    setShowFaq(!showFaq);
    faqClick("faq");
    setCustomADL({ ...customADL, "cta": Date.now() })

  }

  const handleFaqOnClick = (faqText) => {

    faqClick(faqText);
    setCustomADL({ ...customADL, "cta": Date.now() })

  }


  return (
    <>
      <article className="faq">
        <div className="container">
          <button
            className="mb-md-4 faq_btn"
            onClick={faqAccordionClick}
          >
            FAQs{" "}
            {showFaq ? (
              <ImMinus className="ms-4" />
            ) : (
              <FaPlus className="ms-4" />
            )}{" "}
          </button>

          {showFaq && (
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTwo">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="true"
                    aria-controls="collapseTwo"
                    onClick={() => { handleFaqOnClick('What is the Salary eligibility for opening a Salary Account?') }}
                  >
                    What is the Salary eligibility for opening a Salary Account?
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse show"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body pt-0">
                    <p>Any individual employed in any organisation and drawing a monthly salary can open a Salary Account with ICICI Bank. ICICI Bank offers Salary Account for every life stage basis the salary bracket.&nbsp;</p>

                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingThree">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                    onClick={() => { handleFaqOnClick('What documents are required in opening a Salary account with ICICI Bank?') }}
                  >
                    What documents are required in opening a Salary account with ICICI Bank?
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body pt-0">
                    <p>You need the following documents to open a Salary Account with ICICI Bank:</p>
                    <ol>
                      <li>Original PAN Card</li>
                      <li>Original Aadhar Card</li>
                      <li>Proof of Employment</li>
                    </ol>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingFour">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                    onClick={() => { handleFaqOnClick('Do we have to maintain any Average Balance in a Salary Account once it is active?') }}
                  >
                    Do we have to maintain any Average Balance in a Salary Account once it is active?
                  </button>
                </h2>
                <div
                  id="collapseFour"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingFour"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body pt-0">
                    <p>No, there is no requirement to maintain Average Monthly Balance in case of a Salary Account.</p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingFive">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFive"
                    aria-expanded="false"
                    aria-controls="collapseFive"
                    onClick={() => { handleFaqOnClick('Do we get a Debit Card with a Salary Account?') }}
                  >
                    Do we get a Debit Card with a Salary Account?
                  </button>
                </h2>
                <div
                  id="collapseFive"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingFive"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body pt-0">
                    <p>Yes.</p>

                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingSix">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseSix"
                    aria-expanded="false"
                    aria-controls="collapseSix"
                    onClick={() => { handleFaqOnClick('Are there any charges for a Debit Card?') }}
                  >
                    Are there any charges for a Debit Card?
                  </button>
                </h2>
                <div
                  id="collapseSix"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingSix"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body pt-0">
                    <p>Debit Card offered with a Salary Account is complimentary except for Regular Salary Account.</p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingSeven">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseSeven"
                    aria-expanded="false"
                    aria-controls="collapseSeven"
                    onClick={() => { handleFaqOnClick('Will I get a Cheque Book for my Salary Account?') }}
                  >
                    Will I get a Cheque Book for my Salary Account?
                  </button>
                </h2>
                <div
                  id="collapseSeven"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingSeven"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body pt-0">
                    <p>Yes.</p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingEight">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseEight"
                    aria-expanded="false"
                    aria-controls="collapseEight"
                    onClick={() => { handleFaqOnClick('Do we get any Insurance benefit with a Salary Account? If yes, what is the condition to get the claim?') }}
                  >
                    Do we get any Insurance benefit with a Salary Account? If yes, what is the condition to get the claim?
                  </button>
                </h2>
                <div
                  id="collapseEight"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingEight"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body pt-0">
                    <p>A salaried customer who is getting salary credit in ICICI Bank Account will get Personal Accidental Death Insurance and Air Accidental Death Insurance basis his/her Salary Account variant. For more information, <a href="https://www.icicibank.com/personal-banking/accounts/savings-account/insurance-cover/terms-and-conditions">click here</a></p>
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTen">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTen"
                    aria-expanded="false"
                    aria-controls="collapseTen"
                    onClick={() => { handleFaqOnClick('Can we extend the Salary Account benefits to Family Members?') }}
                  >
                    Can we extend the Salary Account benefits to Family Members?
                  </button>
                </h2>
                <div
                  id="collapseTen"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTen"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body pt-0">
                    <p>Yes, you can extend Salary Account benefits to 5 more accounts - parents, spouse &amp; children.</p>
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTen1">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTen1"
                    aria-expanded="false"
                    aria-controls="collapseTen1"
                    onClick={() => { handleFaqOnClick('If we have an existing ICICI Bank Savings Account, can we convert the same to a Salary Account?') }}
                  >
                    If we have an existing ICICI Bank Savings Account, can we convert the same to a Salary Account?
                  </button>
                </h2>
                <div
                  id="collapseTen1"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTen1"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body pt-0">
                    <p>Yes, you will have to submit your bank account details to your Company HR and update Company details through the iMobile App.</p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTen2">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTen2"
                    aria-expanded="false"
                    aria-controls="collapseTen2"
                    onClick={() => { handleFaqOnClick('Is there any RM assigned to Salary Account Customers?') }}
                  >
                    Is there any RM assigned to Salary Account Customers?
                  </button>
                </h2>
                <div
                  id="collapseTen2"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTen2"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body pt-0">
                    <p>Yes, an RM is assigned to Salaried Customers basis the Account variant.&nbsp;</p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTen3">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTen3"
                    aria-expanded="false"
                    aria-controls="collapseTen3"
                    onClick={() => { handleFaqOnClick('Why do I have to add nominee to my Salary Account?') }}
                  >
                    Why do I have to add nominee to my Salary Account?
                  </button>
                </h2>
                <div
                  id="collapseTen3"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTen3"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body pt-0">
                    <p>Nominee addition is necessary because in case of any unfortunate event with the account holder, the nominee will obtain all the benefits and funds.</p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTen4">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTen4"
                    aria-expanded="false"
                    aria-controls="collapseTen4"
                    onClick={() => { handleFaqOnClick('What are the different channels through which I can access my ICICI Bank Salary Account?') }}
                  >
                    What are the different channels through which I can access my ICICI Bank Salary Account?
                  </button>
                </h2>
                <div
                  id="collapseTen4"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTen4"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body pt-0">
                    <p>You can access your Salary Account through:</p>
                    <ol>
                      <li>ICICI Bank Branch</li>
                      <li>ICICI Bank ATMs</li>
                      <li>ICICI Bank Phone Banking</li>
                      <li>ICICI Bank Mobile Banking</li>
                      <li>ICICI Bank WhatsApp Banking.</li>
                    </ol>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTen5">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTen5"
                    aria-expanded="false"
                    aria-controls="collapseTen5"
                    onClick={() => { handleFaqOnClick('How do I update mobile number for my ICICI Bank Salary Account?') }}
                  >
                    How do I update mobile number for my ICICI Bank Salary Account?
                  </button>
                </h2>
                <div
                  id="collapseTen5"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTen5"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body pt-0">
                    <p>You can update the mobile number through any of the following channels:</p>
                    <p className="mb-0"><b>ICICI Bank ATM:</b></p>
                    <p>Visit any ICICI Bank ATM &gt; Select ‘More options’ &gt; Register your mobile number &gt; Enter the mobile number. Your mobile number will be updated in one working day.</p>
                    <p className="mb-0"><b>ICICI Bank Branch:</b></p>
                    <p>Please visit any ICICI Bank Branch along with your original photo ID proof. Once the request is made, your mobile number will be updated in &lt;2&gt; working days. To locate the nearest ICICI Bank Branch, visit&nbsp;<a href="http://maps.icicibank.com/mobile">maps.icicibank.com/mobile</a> .</p>
                    <p>We have discontinued mobile number registration/ de-registration/ modification through our Customer Care and Internet Banking due to security reasons.</p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTen6">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTen6"
                    aria-expanded="false"
                    aria-controls="collapseTen6"
                    onClick={() => { handleFaqOnClick('How do I generate my Internet Banking Password?') }}
                  >
                    How do I generate my Internet Banking Password?
                  </button>
                </h2>
                <div
                  id="collapseTen6"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTen6"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body pt-0">
                    <p>You will be able to place a request for Internet Banking Password through the below mentioned channels:</p>
                    <p className="mb-0"><b>Internet Banking:</b></p>
                    <p>You can generate your login password at www.icicibank.com &gt; Click on ‘Internet Banking’ (Bottom of the page) &gt; ‘Get Started’ &gt; ‘I Want my Password’</p>
                    <p className="mb-0"><b>Customer Care:</b></p>
                    <p>You may place a request by calling our Customer Care between 7:00 a.m. and 9:00 p.m. from your registered mobile number. To know the Customer Care numbers, we request you to&nbsp;<a href="https://www.icicibank.com/customer-care.page"><b>click here</b></a><b>&nbsp;.</b></p>
                    <p className="mb-0"><b>ICICI Bank Branch:</b></p>
                    <p>Visit any ICICI Bank Branch along with original photo ID proof.</p>
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTen7">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTen7"
                    aria-expanded="false"
                    aria-controls="collapseTen7"
                    onClick={() => { handleFaqOnClick('How do I port my ICICI Bank Salary Account from one branch to another?') }}
                  >
                    How do I port my ICICI Bank Salary Account from one branch to another?
                  </button>
                </h2>
                <div
                  id="collapseTen7"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTen7"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body pt-0">
                    <p>You can transfer your account from one branch to another using iMobile App or Internet Banking.</p>
                    <p className="mb-0"><b>Using iMobile App:</b></p>
                    <p>iMobile App &gt; Login &gt; Services &gt; Account Services &gt; Transfer Your Accounts &gt; Select Account number &gt; Yes &gt; Select State / Select Branch.</p>
                    <p className="mb-0"><b>Using Internet Banking:</b></p>
                    <p>Internet Banking &gt; My Accounts &gt; Bank Accounts &gt; Service Requests &gt; Transfer Your Account Online &gt; Account will be transferred within 2 working days.</p>
                  </div>
                </div>
              </div>
              <hr />
            </div>
          )}
        </div>
      </article>

    </>
  );
}

export default Faq;
